import { useEffect } from "react";

const DEFAULT_TITLE = "EventMarket Pro — Marketplace événementielle française";
const DEFAULT_DESC =
  "EventMarket Pro réunit organisateurs, exposants, lieux d'exception et prestataires au service de l'événementiel français. Trouvez un événement, réservez un stand, louez un lieu.";
const DEFAULT_IMAGE = "https://eventmarketpro.fr/og-cover.jpg";

function setMeta(selector, attr, content) {
  if (!content) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, val] = selector.match(/\[(\w+)="([^"]+)"\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight SEO hook — updates <title>, description, OG and Twitter tags.
 * No external dependency. Works for the SPA's per-page tags after hydration.
 */
export default function useSEO({ title, description, image, canonical, type = "website" } = {}) {
  useEffect(() => {
    const finalTitle = title ? `${title} — EventMarket Pro` : DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    const finalImage = image || DEFAULT_IMAGE;
    const finalCanonical = canonical || (typeof window !== "undefined" ? window.location.href.split("?")[0] : "");

    document.title = finalTitle;
    setMeta('meta[name="description"]', "content", finalDesc);
    setMeta('meta[property="og:title"]', "content", finalTitle);
    setMeta('meta[property="og:description"]', "content", finalDesc);
    setMeta('meta[property="og:image"]', "content", finalImage);
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[property="og:url"]', "content", finalCanonical);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", finalTitle);
    setMeta('meta[name="twitter:description"]', "content", finalDesc);
    setMeta('meta[name="twitter:image"]', "content", finalImage);
    setLink("canonical", finalCanonical);
  }, [title, description, image, canonical, type]);
}
